// Authoritative mock pricing. The pricing engine is the only source of truth
// in production (see feedback_pricing_engine_authority); this file simply
// mirrors the current approved values from memory so the ports render real
// numbers without ever typing a price into component code.
//
// TODO(runtime): swap this static table for a call into
// services/sales-bundle-pricing or the pricing engine endpoint once the
// read endpoint lands.
export interface PriceEntry {
  sku: string;
  name: string;
  detail: string;
  oneTime: number;
  subscription: number;
  size: string;
  tint: string;
  color: string;
  square: string;
}

export const MOCK_PRICING: PriceEntry[] = [
  {
    sku: 'GX-1G',
    name: 'Gut X',
    detail: 'Digestive support',
    oneTime: 134.79,
    subscription: 107.83,
    size: '1 gallon',
    tint: '#fff0cf',
    color: '#a87922',
    square: 'GX',
  },
  {
    sku: 'JFP-1G',
    name: 'Joint Flex Plus',
    detail: 'Joint support',
    oneTime: 134.79,
    subscription: 107.83,
    size: '1 gallon',
    tint: '#e4edff',
    color: '#547fb1',
    square: 'JF',
  },
  {
    sku: 'MC-1G',
    name: 'Max Calm',
    detail: 'Calming support',
    oneTime: 134.79,
    subscription: 107.83,
    size: '1 gallon',
    tint: '#fae8dd',
    color: '#b77d50',
    square: 'MC',
  },
  {
    sku: 'OM-1G',
    name: 'Osteo-MAX',
    detail: 'Bone support',
    oneTime: 231.56,
    subscription: 185.25,
    size: '1 gallon',
    tint: '#e8f2df',
    color: '#628252',
    square: 'OM',
  },
  {
    sku: 'AM-1G',
    name: 'Amino-MAX',
    detail: 'Amino acid support',
    oneTime: 176.94,
    subscription: 141.55,
    size: '1 gallon',
    tint: '#f0e5f8',
    color: '#916da7',
    square: 'AM',
  },
  {
    sku: 'HM-1G',
    name: 'Hydra-MAX',
    detail: 'Hydration support',
    oneTime: 117.56,
    subscription: 94.05,
    size: '1 gallon',
    tint: '#dbf4f6',
    color: '#328a94',
    square: 'HM',
  },
];

export function priceFor(name: string, subscription: boolean): number {
  const entry = MOCK_PRICING.find((p) => p.name === name);
  if (!entry) return 0;
  return subscription ? entry.subscription : entry.oneTime;
}

export function priceEntryFor(name: string): PriceEntry | undefined {
  return MOCK_PRICING.find((p) => p.name === name);
}

export function formatUsd(n: number): string {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
}
